import React from 'react';

import { postWebUiApi } from '../../api';
import { WebUiAlert } from '../../components/alert';
import { WebUiButton } from '../../components/button';
import WebUiPageWrapper from '../../components/page-wrapper';

type IgnitionStatus = { enabled?: boolean; V2Active?: boolean; timer?: number };

export default function WebUiStatusIgnitionPage() {
  const [v2, setV2] = React.useState('not powered');
  const [timer, setTimer] = React.useState('0');
  const [statusText, setStatusText] = React.useState(
    'ignition timer: disabled',
  );
  const [error, setError] = React.useState<string | null>(null);

  const reload = React.useCallback(async () => {
    const data = await postWebUiApi<IgnitionStatus>({
      service: 'ignition',
      access: 'get',
      command: 'status',
    });
    if (data.enabled === false) {
      setV2('not powered');
      setTimer('0');
      setStatusText('ignition timer: disabled');
      return;
    }
    setTimer(String(data.timer ?? 0));
    setV2(data.V2Active ? 'powered' : 'not powered');
    setStatusText(
      data.V2Active
        ? 'ignition timer: enabled'
        : `ignition timer: ${data.timer ?? 0}s remaining`,
    );
  }, []);

  React.useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        await reload();
        if (alive) setError(null);
      } catch (err) {
        if (alive) setError((err as Error).message);
      }
    };
    load().catch(() => {});
    const timerId = window.setInterval(() => load().catch(() => {}), 2000);
    return () => {
      alive = false;
      window.clearInterval(timerId);
    };
  }, [reload]);

  return (
    <WebUiPageWrapper titleList={['Status', 'Ignition']}>
      {error ? <WebUiAlert type="error" message={error} /> : null}
      <div className="webui-panel w-[calc(50%-20px)]">
        <div className="flex flex-col gap-2">
          <h4 className="font-bold">Ignition Status</h4>
          <table className="webui-table w-full">
            <tbody>
              <tr className="webui-table-row-head">
                <td>Parameter</td>
                <td>Value</td>
              </tr>
              <tr className="webui-table-row-content">
                <td>V2 / Ignition</td>
                <td>{v2}</td>
              </tr>
              <tr className="webui-table-row-content">
                <td>Timer value in seconds</td>
                <td>{timer}</td>
              </tr>
              <tr className="webui-table-row-content">
                <td>Status</td>
                <td>{statusText}</td>
              </tr>
            </tbody>
          </table>
          <div className="mt-2">
            <WebUiButton onClick={() => reload().catch(() => {})}>
              Reload
            </WebUiButton>
          </div>
        </div>
      </div>
    </WebUiPageWrapper>
  );
}
